<template>
	<button
		v-bind="$attrs"
		class="button-step"
		:class="{ __active: isActive, __past: isPast }"
		:disabled="isDisabled"
		@click="onClick"
	>
		<slot>Button</slot>
	</button>
</template>

<script setup lang="ts">
interface Props {
	disabled?: boolean
	isActive?: boolean
	isPast?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	disabled: false,
	isActive: false,
	isPast: false,
})

const emit = defineEmits(['click'])

const isDisabled = computed(() => !props.isPast && !props.isActive)

const onClick = () => {
	emit('click')
}
</script>
